import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMinusSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M6 11H18V13H6V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinusSmall;
